import { SyncOptions } from "@webapp/rd/ResearchDataModel"
import { WorkspaceSourceDetails, WorkspaceSourceGraph } from "./SyncSessionModel"

export class SyncSessionState {
    readonly sessionId: string
    sourceDetails?: WorkspaceSourceDetails
    sourceGraph?: WorkspaceSourceGraph
    livingStartPersonId?: string
    livingWindowPersonIds: string[] = []
    syncOptions = defaultSyncOptions()
    syncId?: string

    constructor(sessionId: string) {
        this.sessionId = sessionId
    }
}

function defaultSyncOptions() {
    const options = new SyncOptions()
    options.includeLivingPersons = true
    return options
}
